import { Button } from "antd";
import { useTranslation } from "next-i18next";
import { CATEGORY_TYPE, URL_TEMPLATE, USER_ROLES_ENUM } from "src/libs/constant";
import { useGetCategories } from "src/hooks/useGetCategoriesV2";
import { getDateV2 } from "src/libs/util";
import { timeConvertHHmm } from "src/libs/date";
import { getUserId, hasRole } from "src/libs/browser";
import { useGetData } from "src/hooks/useGetData";
import commonApi from "src/api/commonApi";

export default function EnterClassInButton ({
  sessionId,
  title,
  sessionStatus,
  className,
  size = "middle",
  style,
  children,
  classTimeSlotId,
  learnDate,
  teacherId,
  sessionType = ''
}) {
  const { t } = useTranslation();
  const isShowButton = isShowButtonEnterClass({ classTimeSlotId, learnDate, teacherId })

  return (
    <>
      {
        isShowButton && sessionId && (
          <a href={`${URL_TEMPLATE.REDIRECT_ENTER_CLASS}?sessionId=${sessionId}&sessionType=${sessionType}`} target="_blank">
            {children ? (
              children
            ) : (
              <Button
                size={size}
                style={style}
                className={className}
                type="primary"
              >
                {title || t("common.text.enter_class")}
              </Button>
            )}
          </a>
        )
      }
    </>
  )
}

export const isShowButtonEnterClass = ({ classTimeSlotId, learnDate, teacherId }) => {
  const { getCategoryData: getTimeSlot } = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)
  const roleEnterClass = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.MANAGER_TEACHER, USER_ROLES_ENUM.MANAGER_MONITOR])
  const userId = getUserId() == teacherId
  const role = userId || roleEnterClass
  const { data: timeServer } = useGetData(commonApi.getTimeSever)

  if(classTimeSlotId && learnDate) {
    const { startTime, endTime } = getTimeSlot(classTimeSlotId) || {}
    const timeLearning = getDateV2(learnDate, timeConvertHHmm(startTime)).getTime()
    const endTimeLearning = getDateV2(learnDate, timeConvertHHmm(endTime)).getTime()
    const currentTime = new Date().getTime()
    const vnTime = toGMT7(timeServer)
    
    return vnTime >= timeLearning - 5 * 60 * 1000 && vnTime <= endTimeLearning && role
  }
  return false
}
export const isFinish = ({ classTimeSlotId, learnDate, teacherId }) => {
  const { getCategoryData: getTimeSlot } = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)
  const roleEnterClass = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.MANAGER_TEACHER, USER_ROLES_ENUM.MANAGER_MONITOR])
  const userId = getUserId() == teacherId
  const role = userId || roleEnterClass
  const { data: timeServer } = useGetData(commonApi.getTimeSever)

  if(classTimeSlotId && learnDate) {
    const { endTime } = getTimeSlot(classTimeSlotId) || {}
    const endTimeLearning = getDateV2(learnDate, timeConvertHHmm(endTime)).getTime()
    const vnTime = toGMT7(timeServer)
    return vnTime >= endTimeLearning && role
  }
  return false
}
export function toGMT7(timestamp) {
  const date = new Date(timestamp);
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  return new Date(utc + 7 * 3600000); 
}